<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="2" class="py-0">
          <v-autocomplete
            outlined
            flat
            dense
            background-color="white"
            item-text="name"
            item-value="id"
            v-model="params.bankId"
            :items="listBank"
            :rules="[v => !!v || 'Bank is required']"
            @change="onChangebank"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="2" class="py-0">
          <v-autocomplete
            outlined
            flat
            dense
            background-color="white"
            item-text="number"
            item-value="id"
            v-model="params.bankAccountNumberId"
            :items="accountNumbers"
            :rules="[v => !!v || 'Account Number is required']"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3" class="py-0">
          <v-menu
            v-model="menuStartDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="params.startDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="params.startDate"
              @input="menuStartDate = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3" class="py-0">
          <v-menu
            v-model="menuEndDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="params.endDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="params.endDate" @input="menuEndDate = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" sort-by="no" @click:row="onClickRow">
        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn color="warning" dark rounded @click="openSequence" class="mr-2">
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn color="primary" dark rounded @click="initialize" class="mr-2">
              <v-icon>
                mdi-magnify
              </v-icon>
            </v-btn>
            <v-btn color="success" dark rounded :to="{ name: 'Create Bank Statement' }">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ item }">
          {{ items.findIndex(x => x === item) + 1 }}
        </template>
        <template v-slot:item.amount="{ item }">
          {{ formatPrice(item.amount) }}
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <dialog-sequence :dialog="dialog" :item="item" @close="close" @save="save"></dialog-sequence>
  </v-row>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import DialogSequence from "./DialogSequence.vue";

export default {
  computed: {
    ...mapState("bank", ["listBank"]),
  },
  components: {
    DialogSequence,
  },
  data: () => ({
    dialog: false,
    item: {},
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Date", value: "date", sortable: false },
      { text: "Description", value: "description", sortable: false },
      { text: "Transaction Code", value: "transactionCode", sortable: false },
      { text: "Type", value: "type", sortable: false },
      { text: "Amount", value: "amount", sortable: false },
      { text: "Bank", value: "bankName", sortable: false },
    ],
    items: [],
    params: {
      bankId: null,
      bankAccountNumberId: null,
      startDate: moment()
        .startOf("month")
        .format("yyyy-MM-DD"),
      endDate: moment()
        .endOf("month")
        .format("yyyy-MM-DD"),
    },
    menuEndDate: false,
    menuStartDate: false,
    accountNumbers: [],
  }),

  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async initialize() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("bankStatement/getAll", this.params)
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    onClickRow(item) {
      this.$router.push({ name: "Detail Bank Statement", params: { id: item.id } });
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([this.getTransactionCode(), await this.$store.dispatch("bank/dropdown")])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    onChangebank(val) {
      const bank = this.listBank.find(x => x.id === val);
      this.accountNumbers = bank.accountNumbers;
    },
    async getTransactionCode() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("bankStatement/getTransactionCode")
        .then(response => {
          this.item = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async save(item) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("bankStatement/updateBankTransactionCode", item)
        .then(() => {
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    openSequence() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
  mounted() {
    this.getInitialData();
  },
};
</script>

<style></style>
